function Footer() {
    return (
        <footer className="w-full border-t border-gray-100 bg-white mt-auto">
            <div className="max-w-4xl mx-auto px-4 py-12">
                {/* Main Footer Content */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    {/* Column 1: signed */}
                    <div>
                        <h3 className="font-semibold text-gray-900 mb-4">signed</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="/about" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    About
                                </a>
                            </li>
                            <li>
                                <a href="/company/directory" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Companies
                                </a>
                            </li>
                            <li>
                                <a href="/remote-companies" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Remote
                                </a>
                            </li>
                            <li>
                                <a href="/roadmap" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Roadmap
                                </a>
                            </li>
                            <li>
                                <a href="/privacy" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a href="/terms" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Terms of Use
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Column 2: Jobs by Team */}
                    <div>
                        <h3 className="font-semibold text-gray-900 mb-4">Jobs by Team</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="/engineering" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Engineering
                                </a>
                            </li>
                            <li>
                                <a href="/design" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Design
                                </a>
                            </li>
                            <li>
                                <a href="/product" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Product
                                </a>
                            </li>
                            <li>
                                <a href="/sales" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Sales
                                </a>
                            </li>
                            <li>
                                <a href="/marketing" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Marketing
                                </a>
                            </li>
                            <li>
                                <a href="/customer-success" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Customer Success
                                </a>
                            </li>
                            <li>
                                <a href="/support" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Support
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Column 3: Jobs by Stage */}
                    <div>
                        <h3 className="font-semibold text-gray-900 mb-4">Jobs by Stage</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="/stage/pre-seed" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Pre-Seed
                                </a>
                            </li>
                            <li>
                                <a href="/stage/seed" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Seed
                                </a>
                            </li>
                            <li>
                                <a href="/stage/series-a" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Series A
                                </a>
                            </li>
                            <li>
                                <a href="/stage/series-b" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Series B
                                </a>
                            </li>
                            <li>
                                <a href="/stage/series-c-plus" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Series C+
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Column 4: Remote Jobs */}
                    <div>
                        <h3 className="font-semibold text-gray-900 mb-4">Remote Jobs</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="/remote/engineering" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Remote Engineering
                                </a>
                            </li>
                            <li>
                                <a href="/remote/design" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Remote Design
                                </a>
                            </li>
                            <li>
                                <a href="/remote/product" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Remote Product
                                </a>
                            </li>
                            <li>
                                <a href="/remote/sales" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Remote Sales
                                </a>
                            </li>
                            <li>
                                <a href="/remote/marketing" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Remote Marketing
                                </a>
                            </li>
                            <li>
                                <a href="/remote/customer-success" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Remote Customer Success
                                </a>
                            </li>
                            <li>
                                <a href="/remote/support" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                    Remote Support
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="pt-8 border-t border-gray-100">
                    <p className="text-sm text-gray-600 text-center">
                        © {new Date().getFullYear()} signed. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer
